import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppState } from '../../../reducers';
import { UserReview } from '../types';
import { ProductUserReviews, StoreUserReviews } from '../../../types';

type Props = {
  initialNodes?: UserReview[];
  initialMyReview?: UserReview | null;
  pageInfo?: ProductUserReviews['pageInfo'] | StoreUserReviews['pageInfo'];
  pageType: 'store' | 'product' | 'profile' | 'shopOfTheYear';
};

type UpdatedReviews = {
  shopId: number;
  nodes: UserReview[];
  myReview: UserReview;
} | null;

const useReviewData = ({
  initialNodes,
  initialMyReview,
  pageInfo,
  pageType,
}: Props) => {
  const dispatch = useDispatch();

  const updatedReviews: UpdatedReviews = useSelector(
    (state: AppState) => state.areas.review.updatedReviews
  );

  useEffect(() => {
    if (pageInfo) {
      dispatch({ type: 'SET_SHOP_REVIEW_PAGEINFO', pageInfo, pageType });
    }
  }, [pageInfo?.limit, pageType]);

  return useMemo(
    () => ({
      myReview: updatedReviews ? updatedReviews.myReview : initialMyReview,
      reviews: updatedReviews?.nodes || initialNodes || [],
    }),
    [updatedReviews, initialNodes, initialMyReview]
  );
};

export default useReviewData;
